module.exports = __webpack_public_path__ + "img/black-and-white-snapping-finger.e037ea24.png";